var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 32.5195C0.5 14.8465 14.827 0.519531 32.5 0.519531C50.173 0.519531 64.5 14.8465 64.5 32.5195C64.5 50.1925 50.173 64.5195 32.5 64.5195C14.827 64.5195 0.5 50.1925 0.5 32.5195Z",
    fill: "#BA51D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 20.5195C35.981 20.5195 40.011 24.1625 40.62 28.8775L43.321 33.1235C43.499 33.4035 43.463 33.8215 43.051 33.9975L40.7 35.0045V38.5195C40.7 39.8445 39.626 40.9195 38.3 40.9195H35.901L35.9 44.5195H25.1V40.0865C25.1 38.6695 24.576 37.3295 23.607 36.1205C22.288 34.4775 21.5 32.3905 21.5 30.1195C21.5 24.8175 25.798 20.5195 31.1 20.5195ZM30.464 27.4345C29.644 26.6145 28.314 26.6145 27.494 27.4345C26.674 28.2545 26.674 29.5845 27.494 30.4045L31.1 34.0105L34.706 30.4045C35.526 29.5845 35.526 28.2545 34.706 27.4345C33.886 26.6145 32.556 26.6145 31.736 27.4345L31.1 28.0705L30.464 27.4345Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5 0.519531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.439cfe8191d1e9c6e85a6b5fb02748eb.svg";
export { ForwardRef as ReactComponent };